import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-entities',
  templateUrl: './client-entities.component.html',
  styleUrls: ['./client-entities.component.scss']
})
export class ClientEntitiesComponent implements OnInit {

  entities: Entities[] = [
    {
      icon: 'bi-display',
      name: 'Sessions',
      description: 'Manage your sessions',
      route: 'sessions',
      toShow: true
    },
    //{
    //  icon: 'bi-boxes',
    //  name: 'Applications',
    //  description: 'Manage your applications',
    //  route: 'applications',
    //  toShow: true
    //},
  ]

  constructor() { }

  ngOnInit(): void {
  }

}

interface Entities {
  icon: string;
  name: string;
  description: string;
  route: string;
  toShow: boolean;
}
